import React from 'react';
import LaneContainer from '../UI/LaneContainer';
import YourBooksSectionHeader from '../YourBooks/YourBooksSectionHeader';
import ShelvesCollapse from './ShelvesCollapse';
import ShelvesMenu from './ShelvesMenu';

export default class Shelves extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showInGrid: false,
		};
	}

	componentDidMount() {
		this.initializeSource();
	}

	initializeSource = () => {
		if (this.props.match) {
			this.setState({ showInGrid: true });
		}
	};

	render() {
		const { showInGrid } = this.state;
		return (
			<div
				style={{
					marginTop: showInGrid ? 64 : 0,
				}}>
				<LaneContainer
					majorHeader={
						<YourBooksSectionHeader
							headerText="Your Shelves"
							showInGrid={showInGrid}
						/>
					}>
					<div>
						{showInGrid ? <ShelvesMenu /> : <ShelvesCollapse />}
					</div>
				</LaneContainer>
			</div>
		);
	}
}
